module.exports = __webpack_public_path__ + "img/tashkent.68a5dba9.png";